import type { styleFn } from 'styled-system';
import { variant } from 'styled-system';

import { addCustomProps } from './shouldForwardProp';

const variantFactory: styleFn = (scale: string, { prop = 'variant' } = {}) => {
  // Add the prop to the list of custom props so that it's caught by our
  // shouldForwardProp function. This ensures that the prop is only used in JS
  // and not added as an attribute in the HTML output.
  if (prop !== 'variant') {
    addCustomProps([prop]);
  }

  return variant({
    prop,
    scale,
    variants: {
      default: null,
    },
  });
};

export default variantFactory;
